import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import Routes from './routes/';

function App() {
  return (
    <BrowserRouter>
      <ToastContainer pauseOnFocusLoss={false} limit={3} autoClose={3000} />
      <Routes />
    </BrowserRouter>
  );
}

export default App;
